import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Toast, ToasterType } from '../interfaces/toast';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ToastersService {
  newToast: BehaviorSubject<Toast> = new BehaviorSubject<Toast>(null);
  removeByTimestampSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(private authService: AuthService, private notificationService: NotificationService) {
    notificationService.newNotification.subscribe((notification) => {
      if (notification) {
        const { id } = this.authService.getUser();
        if (notification.createdByUserId !== id) {
          const { body, link, id: notificationId } = notification;
          this.createToast('Info', body, link, notificationId);
        }
      }
    });
  }

  /**
   *
   * @description partialLink is the route without tenant type
   * @description So basically instead of passing '/tenant/jobs', you just pass '/jobs'
   * @deprecated This can still be used, but it's better to replace it with createNewToast
   *
   */
  createToast(type: ToasterType, title = '', partialLink = '', notificationId = '', isStatusToast = false) {
    if (!type || !title) {
      return;
    }
    const tenant = this.authService.getTenant();
    const link = partialLink ? `/${tenant.type}${partialLink}` : null;
    const timestamp = new Date().getTime();
    const toast: Toast = {
      type,
      timestamp,
      title,
      link,
      notificationId,
      isStatusToast,
    };
    this.newToast.next(toast);
    return toast;
  }

  createNewToast({
    type,
    title,
    partialLink,
    notificationId,
    isStatusToast,
  }: {
    type: ToasterType;
    title: string;
    partialLink?: string;
    notificationId?: string;
    isStatusToast?: boolean;
  }) {
    if (!type || !title) {
      return;
    }
    const tenant = this.authService.getTenant();
    const link = partialLink ? `/${tenant.type}${partialLink}` : null;
    const timestamp = new Date().getTime();
    const toast: Toast = {
      type,
      timestamp,
      title,
      link,
      notificationId,
      isStatusToast,
    };
    this.newToast.next(toast);
    return toast;
  }

  createErrorToast(title: string) {
    if (!title) return;
    return this.createToast('Error', title);
  }
}
